import React, { useCallback } from 'react';
import { Button, Icon, IconButton } from '@medely/ui-kit';
import { useMaskedPhoneNumberMutations } from '@mp/hooks';
import useDialog from '@mp/hooks/useDialog';
import { CallFacilityDialog } from './CallFacilityDialog';

type ContactFacilityProps = {
  phone?: string | null;
  contactableId?: number | null;
  type: 'job' | 'assignment';
  smallIcon?: boolean;
  isIconButton?: boolean;
};

const ContactFacility = ({
  contactableId,
  phone,
  type,
  smallIcon = false,
  isIconButton = false,
}: ContactFacilityProps) => {
  const { requestJobMaskedNumber, requestAssignmentMaskedNumber, isLoading } =
    useMaskedPhoneNumberMutations();
  const { open, openDialog, closeDialog } = useDialog();

  const handleCall = useCallback(() => {
    if (!phone && contactableId) {
      if (type === 'job') {
        requestJobMaskedNumber(contactableId as number, { onSuccess: openDialog });
      } else {
        requestAssignmentMaskedNumber(contactableId as number, {
          onSuccess: openDialog,
        });
      }
    } else {
      openDialog();
    }
  }, [contactableId, phone]);

  return (
    <>
      {isIconButton ? (
        <IconButton
          tooltip="open in maps"
          variant="contained"
          color="secondary"
          icon={
            <Icon
              name="light-phone"
              iconSize={smallIcon ? '14px' : '20px'}
              color="text.primary"
              variant="custom"
            />
          }
          onClick={handleCall}
        />
      ) : (
        <Button
          fullWidth
          variant="outlined"
          loading={isLoading}
          onClick={handleCall}
          testId="contact-facility-button"
          startIcon={
            <Icon
              name="phone"
              iconSize={smallIcon ? '14px' : '20px'}
              color="text.primary"
              variant="custom"
            />
          }
        >
          Call facility
        </Button>
      )}

      <CallFacilityDialog open={open} onClose={closeDialog} phone={phone} />
    </>
  );
};

export default ContactFacility;
